import { render, staticRenderFns } from "./apply-submit.vue?vue&type=template&id=5a923bd7&"
import script from "./apply-submit.vue?vue&type=script&lang=js&"
export * from "./apply-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports